// @flow

export { MobileDisplayValues } from './mobile-display-values';
